module.exports = __webpack_public_path__ + "static/img/image059.d542b6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image059.png
// module id = 4Yvi
// module chunks = 1